import { createContext, ReactNode } from 'react';
import { UseAdCallbacks } from './main-3-ads-ready-provider-utils';

type AdCBs = Record<'adDomReady' | 'adRequest' | 'adResponse', (b: boolean) => void>;

type UseAdPageReady = {
  bannerAd: AdCBs;
  interstitialAd: AdCBs;
};

export const AdDomReadyContext = createContext<UseAdPageReady>({
  bannerAd: {
    adDomReady: () => 0,
    adRequest: () => 0,
    adResponse: () => 0,
  },
  interstitialAd: {
    adDomReady: () => 0,
    adRequest: () => 0,
    adResponse: () => 0,
  },
});

/**
 * Calls ad page reset when pageUrlhasChanged and BannerConfig has populated
 * Fixes bug where fuse was refreshing before banner has updated its attributes
 * Causing ad to populate on old attributes
 */
export const AdDomReadyProvider = ({
  children,
  rendersBannerAd,
  rendersInterstitialAd,
}: {
  children: ReactNode;
  rendersBannerAd?: boolean;
  rendersInterstitialAd?: boolean;
}) => {
  /** BANNER START */

  const { adCBs: bannerAd } = UseAdCallbacks({ rendersAd: rendersBannerAd, name: 'Banner' });
  const { adCBs: interstitialAd } = UseAdCallbacks({ rendersAd: rendersInterstitialAd, name: 'Interstitial' });

  return (
    <AdDomReadyContext.Provider
      value={{
        bannerAd,
        interstitialAd,
      }}
    >
      {children}
    </AdDomReadyContext.Provider>
  );
};
